<umkt-auth-layout scrollable>
  <div class="auth-back" *ngIf="currentStep < 4">
    <a routerLink="/login" *ngIf="currentStep === 1">
      <mat-icon>chevron_left</mat-icon>
      {{ 'pages.register.backToLogin' | i18n }}
    </a>
    <a (click)="previousStep()" *ngIf="currentStep > 1">
      <mat-icon>chevron_left</mat-icon>
      {{ 'shared.buttons.back' | i18n }}
    </a>
    <span *ngIf="!isFromMobileFlow()">
      {{ 'pages.register.stepCounter' | i18n: { current: currentStep, total: 3 } }}
    </span>
  </div>

  <div class="auth-card-content">
    <div class="auth-card-form">
      <div class="auth-intern-form">
        <div *ngIf="currentStep < 4" class="auth-title font-highlight">
          <h1 style="font-size: 1.5rem; font-weight: 600; line-height: 2rem; color: var(--color-neutral-950-to-white);">
            {{ 'pages.register.title' | i18n }} <span class="auth-title-highlight"
              style="font-size: 1.5rem; font-weight: 600; line-height: 2rem">
              {{ 'pages.register.titleHighlight' | i18n }}
            </span>
          </h1>
        </div>

        <!-- Step 1: Company Data -->
        <umkt-register-step1 *ngIf="currentStep === 1"
          [step1Form]="step1Form"
          [isLoadingCNPJ]="isLoadingCNPJ"
          [loading]="loading"
          [nextStep]="nextStep.bind(this)"
          [goToLogin]="goToLogin.bind(this)"
          [preventLeadingSpace]="preventLeadingSpace.bind(this)">
        </umkt-register-step1>

        <!-- Step 2: Address -->
        <umkt-register-step2 *ngIf="currentStep === 2"
          [step2Form]="step2Form"
          [brazilStates]="brazilStates"
          [showCitySuggestions]="showCitySuggestions"
          [filteredCities]="filteredCities"
          [selectedSuggestionIndex]="selectedSuggestionIndex"
          [citySelectedFromList]="citySelectedFromList"
          [loading]="loading"
          [nextStep]="nextStep.bind(this)"
          [preventLeadingSpace]="preventLeadingSpace.bind(this)"
          [onCityKeydown]="onCityKeydown.bind(this)"
          [selectCity]="selectCity.bind(this)"
          [goToLogin]="goToLogin.bind(this)"
          [isFromMobileFlow]="isFromMobileFlow.bind(this)">
        </umkt-register-step2>

        <!-- Step 3: User Data -->
        <umkt-register-step3 *ngIf="currentStep === 3"
          [step3Form]="step3Form"
          [passwordRequirements]="passwordRequirements"
          [loading]="loading"
          [submitRegistration]="submitRegistration.bind(this)"
          [preventLeadingSpace]="preventLeadingSpace.bind(this)"
          [goToLogin]="goToLogin.bind(this)">
        </umkt-register-step3>

        <!-- Step 4: Success -->
        <div *ngIf="currentStep === 4" class="success-container">
          <h2>{{ 'pages.register.success.title' | i18n }}</h2>
          <p>
            {{ 'pages.register.success.message' | i18n: { email: step3Form.get('email')?.value } }}
          </p>
          <a href="#">{{ 'pages.register.success.resendLink' | i18n }}</a>
        </div>
      </div>
    </div>
  </div>
</umkt-auth-layout>